import { defineMessages, IntlShape } from "react-intl";

import { CumulRole } from "@mapmycustomers/shared/enum/cumul/CumulRole";

import { getDisplayName } from "./getDisplayName";

const messages = defineMessages<CumulRole>({
  [CumulRole.DESIGNER]: {
    id: "cumulRole.designer",
    defaultMessage: "Designer",
  },
  [CumulRole.OWNER]: {
    id: "cumulRole.owner",
    defaultMessage: "Owner",
  },
  [CumulRole.VIEWER]: {
    id: "cumulRole.viewer",
    defaultMessage: "Viewer",
  },
});

const getCumulRoleDisplayName = (intl: IntlShape, cumulRole: CumulRole) =>
  getDisplayName(intl, messages, cumulRole, "CumulRole");

export default getCumulRoleDisplayName;
